import React from 'react'

const SvgFeature32 = props => (
  <svg viewBox='0 0 694.17 443.54' {...props}>
    <defs>
      <style>
        {
          '.feature3-2_svg__cls-7{fill:#fd5c1f}.feature3-2_svg__cls-12,.feature3-2_svg__cls-18,.feature3-2_svg__cls-2,.feature3-2_svg__cls-22,.feature3-2_svg__cls-24,.feature3-2_svg__cls-4,.feature3-2_svg__cls-9{fill:#8796aa}.feature3-2_svg__cls-3,.feature3-2_svg__cls-9{font-size:12px}.feature3-2_svg__cls-3,.feature3-2_svg__cls-8{fill:#252a3a}.feature3-2_svg__cls-3{font-family:SourceHanSansCN-Regular-GBpc-EUC-H,Source Han Sans CN}.feature3-2_svg__cls-4{font-size:10px;letter-spacing:.03em}.feature3-2_svg__cls-12,.feature3-2_svg__cls-18,.feature3-2_svg__cls-22,.feature3-2_svg__cls-24,.feature3-2_svg__cls-4,.feature3-2_svg__cls-9{font-family:SourceHanSansCN-Normal-GBpc-EUC-H,Source Han Sans CN}.feature3-2_svg__cls-5{letter-spacing:-.04em}.feature3-2_svg__cls-6{letter-spacing:-.41em}.feature3-2_svg__cls-9{letter-spacing:.02em}.feature3-2_svg__cls-12,.feature3-2_svg__cls-24{font-size:10.1px}.feature3-2_svg__cls-12{letter-spacing:.03em}.feature3-2_svg__cls-13{letter-spacing:-.04em}.feature3-2_svg__cls-14{letter-spacing:-.41em}.feature3-2_svg__cls-15,.feature3-2_svg__cls-24{letter-spacing:.02em}.feature3-2_svg__cls-16{letter-spacing:-.41em}.feature3-2_svg__cls-17{letter-spacing:-.04em}.feature3-2_svg__cls-18{font-size:9.99px;letter-spacing:.02em}.feature3-2_svg__cls-19{letter-spacing:-.04em}.feature3-2_svg__cls-20{letter-spacing:-.41em}.feature3-2_svg__cls-21{letter-spacing:.03em}.feature3-2_svg__cls-22{font-size:12.12px;letter-spacing:.02em}'
        }
      </style>
    </defs>
    <g id='feature3-2_svg__\u56FE\u5C42_2' data-name='\u56FE\u5C42 2'>
      <g id='feature3-2_svg__\u56FE\u5C42_1-2' data-name='\u56FE\u5C42 1'>
        <text
          transform='translate(303.69 312.32)'
          fontFamily='SourceHanSansCN-Medium-GBpc-EUC-H,Source Han Sans CN'
          fill='#fd5c1f'
          fontSize={14}
          letterSpacing='.02em'
        >
          {'\u6587\u4EF6\u6574\u4F53\u6821\u9A8C'}
        </text>
        <path
          className='feature3-2_svg__cls-2'
          d='M602.14 323.54h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-7 0h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm-1 7v1h4v-1zm12 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm3-3v4h1v-4h-1zm1-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4z'
        />
        <text className='feature3-2_svg__cls-3' transform='translate(112.14 400.09)'>
          {'\u53D1\u9001\u7684\u6587\u4EF6'}
        </text>
        <text className='feature3-2_svg__cls-4' transform='translate(224.29 364.09)'>
          {'1.\u6587\u4EF6\u4F20'}
          <tspan className='feature3-2_svg__cls-5' x={39.44} y={0}>
            {'\u8F93'}
          </tspan>
          <tspan className='feature3-2_svg__cls-6' x={49.05} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan x={54.94} y={0}>
            {'\u8FDB\u884CHASH\u6821\u9A8C'}
          </tspan>
        </text>
        <text className='feature3-2_svg__cls-4' transform='translate(224.29 404.09)'>
          {'2.\u68C0\u9A8C\u7ED3\u679C\u4E0D\u4E00'}
          <tspan className='feature3-2_svg__cls-5' x={70.19} y={0}>
            {'\u81F4'}
          </tspan>
          <tspan className='feature3-2_svg__cls-6' x={79.8} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan x={85.69} y={0}>
            {'\u89E6\u53D1\u9519\u8BEF\u91CD\u4F20\u673A'}
          </tspan>
          <tspan className='feature3-2_svg__cls-5' x={157.44} y={0}>
            {'\u5236'}
          </tspan>
          <tspan className='feature3-2_svg__cls-6' x={167.05} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan x={172.94} y={0}>
            {'\u6587\u4EF6\u91CD\u65B0\u4F20\u8F93'}
          </tspan>
        </text>
        <path
          className='feature3-2_svg__cls-7'
          d='M146.46 358.1h-14.25v24h19.86v-18.85zm-12.59 22.34v-20.69h10.76v5h5.79v15.72z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M135.52 368.03h7.73v1.66h-7.73zM135.52 372.17h12.41v1.66h-12.41zM135.52 376.31h12.41v1.66h-12.41zM556.83 358.1h-14.24v24h19.86v-18.85zm-12.59 22.34v-20.69H555v5h5.79v15.72z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M545.9 368.03h7.73v1.66h-7.73zM545.9 372.17h12.41v1.66H545.9zM545.9 376.31h12.41v1.66H545.9z'
        />
        <text className='feature3-2_svg__cls-3' transform='translate(527.89 400.09)'>
          {'\u63A5\u6536\u6587\u4EF6'}
        </text>
        <path
          className='feature3-2_svg__cls-7'
          d='M659.19 376a23.54 23.54 0 00-5.5.78l1.24.89a11.9 11.9 0 01-4.32 0v3.66a17.49 17.49 0 007.31-.66l-.58-.7c.68-.06 1.14-.08 1.85-.08a19.68 19.68 0 015.49.76v-3.88a23.29 23.29 0 00-5.49-.77z'
        />
        <path
          className='feature3-2_svg__cls-8'
          d='M665 390.22a16.6 16.6 0 00-3.09.6v1.08a21.77 21.77 0 01-5.56.52 22.36 22.36 0 01-5.43-1.21v-3.87a16.52 16.52 0 006.7 1.34 21.33 21.33 0 003.86-.37l-.18-1a13.51 13.51 0 013.7-.94zM662.61 381.43a20.11 20.11 0 00-3.83.46l.63 1a16.32 16.32 0 01-3.92.35 18.29 18.29 0 01-6.74-1.35v3.88a19 19 0 005.86 1 19.29 19.29 0 006.19-.94l-.18-.47a15.28 15.28 0 012-.12 15.83 15.83 0 013.95.38v-3.88a23.46 23.46 0 00-3.96-.31z'
        />
        <path
          className='feature3-2_svg__cls-2'
          d='M631 366.54h53.33v34.17h2.5V367a3 3 0 00-3-3h-52.36a3 3 0 00-3 3v33.68H631z'
        />
        <path
          className='feature3-2_svg__cls-2'
          d='M621.81 400.71a3.33 3.33 0 003.33 3.33h65a3.34 3.34 0 003.34-3.33z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M37.38 376a23.54 23.54 0 00-5.5.78l1.24.89a11.9 11.9 0 01-4.32 0v3.66a17.49 17.49 0 007.31-.66l-.58-.7c.68-.06 1.14-.08 1.85-.08a19.68 19.68 0 015.49.76v-3.88a23.29 23.29 0 00-5.49-.77z'
        />
        <path
          className='feature3-2_svg__cls-8'
          d='M43.21 390.22a16.6 16.6 0 00-3.09.6v1.08a21.77 21.77 0 01-5.56.52 22.47 22.47 0 01-5.43-1.21v-3.87a16.52 16.52 0 006.7 1.34 21.33 21.33 0 003.86-.37l-.18-1a13.51 13.51 0 013.7-.94zM40.8 381.43a20.11 20.11 0 00-3.83.46l.63 1a16.32 16.32 0 01-3.92.35 18.29 18.29 0 01-6.74-1.35v3.88a19 19 0 005.86 1 19.29 19.29 0 006.19-.94l-.18-.47a15.28 15.28 0 012-.12 15.83 15.83 0 013.95.38v-3.88a23.46 23.46 0 00-3.96-.31z'
        />
        <path
          className='feature3-2_svg__cls-2'
          d='M9.17 366.54H62.5v34.17H65V367a3 3 0 00-3-3H9.66a3 3 0 00-3 3v33.68h2.5z'
        />
        <path
          className='feature3-2_svg__cls-2'
          d='M0 400.71A3.33 3.33 0 003.33 404h65a3.34 3.34 0 003.34-3.33zM68.53 385.05h25v2h-25z'
        />
        <path className='feature3-2_svg__cls-2' d='M92.95 380.05l8 6-8 6M587.53 385.05h28v2h-28z' />
        <path className='feature3-2_svg__cls-2' d='M614.95 380.05l8 6-8 6' />
        <text className='feature3-2_svg__cls-9' transform='translate(17.38 426.36)'>
          {'\u53D1\u9001\u7AEF'}
        </text>
        <text className='feature3-2_svg__cls-9' transform='translate(638.09 426.36)'>
          {'\u63A5\u6536\u7AEF'}
        </text>
        <path className='feature3-2_svg__cls-2' d='M191.59 371.98h316.5v1.01h-316.5z' />
        <path className='feature3-2_svg__cls-2' d='M507.8 369.46l4 3.03-4 3.03M195.3 385.08h316.5v1.01H195.3z' />
        <path className='feature3-2_svg__cls-2' d='M195.59 382.55l-4 3.03 4 3.03' />
        <text
          transform='translate(303.56 12.31)'
          fontSize={13.99}
          letterSpacing='.02em'
          fontFamily='SourceHanSansCN-Medium-GBpc-EUC-H,Source Han Sans CN'
          fill='#fd5c1f'
        >
          {'\u6587\u4EF6\u5206\u5757\u6821\u9A8C'}
        </text>
        <path
          className='feature3-2_svg__cls-2'
          d='M602.68 23.53h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-6.78.22h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v3.59h1v-3.59zm7.42 2.59h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm7.36 0h-3.36v1h3.36v-1zm0-7.64h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zM206.3 57.62h277.38v1.01H206.3z'
        />
        <path className='feature3-2_svg__cls-2' d='M483.39 55.1l4 3.03-4 3.03' />
        <path
          className='feature3-2_svg__cls-2'
          transform='rotate(-44.99 146.63 96.408)'
          d='M114.89 95.91h63.46v1.01h-63.46z'
        />
        <path className='feature3-2_svg__cls-2' d='M166.72 72.04l4.97-.68-.69 4.96' />
        <path
          className='feature3-2_svg__cls-2'
          transform='rotate(-45.01 146.616 152.102)'
          d='M146.12 120.37h1.01v63.46h-1.01z'
        />
        <path className='feature3-2_svg__cls-2' d='M166.72 176.48l4.97.68-.69-4.97M125.41 125.75h39.48v1.01h-39.48z' />
        <path
          className='feature3-2_svg__cls-2'
          d='M164.6 129.29l4-3.03-4-3.03M105.14 158.77l-2.97-4.05-3.09 3.95M210.01 64.71h277.38v1.01H210.01z'
        />
        <path className='feature3-2_svg__cls-2' d='M210.3 62.19l-4 3.03 4 3.03' />
        <text
          transform='matrix(.71 -.69 .7 .72 119.45 105.26)'
          fontSize={11.99}
          fontFamily='SourceHanSansCN-Regular-GBpc-EUC-H,Source Han Sans CN'
          fill='#252a3a'
        >
          {'\u5206\u5757\u5E76\u53D1'}
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 224.19 50.53)'>
          {'1.\u6587\u4EF6\u57571\u4F20\u8F93\u5B8C'}
          <tspan className='feature3-2_svg__cls-13' x={76.67} y={0}>
            {'\u6210'}
          </tspan>
          <tspan className='feature3-2_svg__cls-14' x={86.38} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-15' x={92.32} y={0}>
            {'\u8FDB\u884C\u6587\u4EF6\u57571\u6821\u9A8C'}
          </tspan>
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 224.19 79.98)'>
          {'2.\u6821\u9A8C\u7ED3\u679C\u4E0D\u4E00'}
          <tspan className='feature3-2_svg__cls-13' x={70.88} y={0}>
            {'\u81F4'}
          </tspan>
          <tspan className='feature3-2_svg__cls-16' x={80.58} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan x={86.53} y={0}>
            {'\u89E6\u53D1\u9519\u8BEF\u91CD\u4F20\u673A'}
          </tspan>
          <tspan className='feature3-2_svg__cls-17' x={158.98} y={0}>
            {'\u5236'}
          </tspan>
          <tspan className='feature3-2_svg__cls-14' x={168.68} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-15' x={174.63} y={0}>
            {'\u6587\u4EF6\u57571\u91CD\u65B0\u4F20\u8F93'}
          </tspan>
        </text>
        <path className='feature3-2_svg__cls-2' d='M206.3 126.57h277.38v1.01H206.3z' />
        <path className='feature3-2_svg__cls-2' d='M483.39 124.05l4 3.03-4 3.03M210.01 133.66h277.38v1.01H210.01z' />
        <path className='feature3-2_svg__cls-2' d='M210.3 131.14l-4 3.03 4 3.03' />
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 224.19 119.48)'>
          {'1.\u6587\u4EF6\u57572\u4F20\u8F93\u5B8C'}
          <tspan className='feature3-2_svg__cls-13' x={76.67} y={0}>
            {'\u6210'}
          </tspan>
          <tspan className='feature3-2_svg__cls-14' x={86.38} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-15' x={92.32} y={0}>
            {'\u8FDB\u884C\u6587\u4EF6\u57572\u6821\u9A8C'}
          </tspan>
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 224.19 148.93)'>
          {'2.\u6821\u9A8C\u7ED3\u679C\u4E00'}
          <tspan className='feature3-2_svg__cls-17' x={60.53} y={0}>
            {'\u81F4'}
          </tspan>
          <tspan className='feature3-2_svg__cls-14' x={70.23} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-15' x={76.18} y={0}>
            {'\u8BE5\u5757\u4F20\u8F93\u7ED3\u675F'}
          </tspan>
        </text>
        <path className='feature3-2_svg__cls-2' d='M206.3 186.53h277.38v1.01H206.3z' />
        <path className='feature3-2_svg__cls-2' d='M483.39 184l4 3.03-4 3.03M210.01 193.62h277.38v1.01H210.01z' />
        <path className='feature3-2_svg__cls-2' d='M210.3 191.09l-4 3.03 4 3.03' />
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 224.19 179.44)'>
          {'1.\u6587\u4EF6\u5757...\u4F20\u8F93\u5B8C'}
          <tspan className='feature3-2_svg__cls-13' x={79.81} y={0}>
            {'\u6210'}
          </tspan>
          <tspan className='feature3-2_svg__cls-16' x={89.52} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan x={95.46} y={0}>
            {'\u8FDB\u884C\u6587\u4EF6\u5757...\u6821\u9A8C'}
          </tspan>
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 224.19 208.89)'>
          {'2.\u6821\u9A8C\u7ED3\u679C\u4E00'}
          <tspan className='feature3-2_svg__cls-17' x={60.53} y={0}>
            {'\u81F4'}
          </tspan>
          <tspan className='feature3-2_svg__cls-14' x={70.23} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-15' x={76.18} y={0}>
            {'\u8BE5\u5757\u4F20\u8F93\u7ED3\u675F'}
          </tspan>
        </text>
        <text className='feature3-2_svg__cls-18' transform='matrix(.99 0 0 1 224.19 240.39)'>
          {'3.\u6587\u4EF6\u4F20\u8F93\u5B8C'}
          <tspan className='feature3-2_svg__cls-19' x={59.9} y={0}>
            {'\u6210'}
          </tspan>
          <tspan className='feature3-2_svg__cls-20' x={69.5} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan x={75.39} y={0}>
            {'\u8FDB\u884CHASH\u6821\u9A8C'}
          </tspan>
        </text>
        <text className='feature3-2_svg__cls-18' transform='matrix(.99 0 0 1 224.19 263.85)'>
          {'4.\u6821\u9A8C\u7ED3\u679C\u4E0D\u4E00'}
          <tspan className='feature3-2_svg__cls-19' x={70.14} y={0}>
            {'\u81F4'}
          </tspan>
          <tspan className='feature3-2_svg__cls-20' x={79.74} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-21' x={85.63} y={0}>
            {'\u89E6\u53D1\u9519\u8BEF\u91CD\u4F20\u673A'}
          </tspan>
          <tspan className='feature3-2_svg__cls-19' x={157.33} y={0}>
            {'\u5236'}
          </tspan>
          <tspan className='feature3-2_svg__cls-20' x={166.93} y={0}>
            {'\uFF0C'}
          </tspan>
          <tspan className='feature3-2_svg__cls-21' x={172.81} y={0}>
            {'\u6587\u4EF6\u91CD\u65B0\u5206\u5757\u5E76\u53D1\u4F20\u8F93'}
          </tspan>
        </text>
        <path
          className='feature3-2_svg__cls-7'
          d='M115.28 115.85H101v24.24h19.9v-19zm-12.58 22.56v-20.89h10.75v5h5.79v15.87z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M104.35 125.88h7.73v1.67h-7.73zM104.35 130.06h12.41v1.67h-12.41zM104.35 134.24h12.41v1.67h-12.41zM188.25 50.23H174v24.23h19.85v-19zm-12.58 22.56V51.9h10.75v5h5.79v15.89z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M177.32 60.26h7.73v1.67h-7.73zM177.32 64.44h12.41v1.67h-12.41zM177.32 68.62h12.41v1.67h-12.41zM188.25 116.18H174v24.24h19.85v-19zm-12.58 22.57v-20.9h10.75v5h5.79v15.88z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M177.32 126.21h7.73v1.67h-7.73zM177.32 130.39h12.41v1.67h-12.41zM177.32 134.57h12.41v1.67h-12.41zM188.25 178.14H174v24.23h19.85v-19zm-12.58 22.56v-20.89h10.75v5h5.79v15.89z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M177.32 188.17h7.73v1.67h-7.73zM177.32 192.34h12.41v1.67h-12.41zM177.32 196.52h12.41v1.67h-12.41zM588.57 116h-14.23v24.23h19.85v-19zM576 138.52v-20.89h10.75v5h5.79v15.88z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M577.64 125.99h7.73v1.67h-7.73zM577.64 130.17h12.41v1.67h-12.41zM577.64 134.34h12.41v1.67h-12.41zM659.9 120.39a23.45 23.45 0 00-5.49.79l1.24.9a11.77 11.77 0 01-4.33 0v3.69a17.32 17.32 0 007.31-.67l-.58-.7a16.06 16.06 0 011.85-.08 19.22 19.22 0 015.49.77v-3.93a23.81 23.81 0 00-5.49-.77z'
        />
        <path
          className='feature3-2_svg__cls-8'
          d='M665.73 134.72a17.38 17.38 0 00-3.09.61v1.09a17.6 17.6 0 01-11-.7v-3.9a16.44 16.44 0 006.7 1.35 21.31 21.31 0 003.85-.37l-.18-1a13.13 13.13 0 013.7-1zM663.33 125.85a19.2 19.2 0 00-3.84.47l.64 1a16 16 0 01-3.92.36 18.21 18.21 0 01-6.74-1.36v3.91a18.67 18.67 0 005.86 1 19.24 19.24 0 006.18-.95l-.18-.48a17.78 17.78 0 015.91.27v-3.87a23.43 23.43 0 00-3.91-.35z'
        />
        <path
          className='feature3-2_svg__cls-2'
          d='M631.7 110.82H685v34.5h2.5v-34a3 3 0 00-3-3h-52.31a3 3 0 00-3 3v34h2.5zM622.54 145.32a3.34 3.34 0 003.33 3.36h65a3.34 3.34 0 003.33-3.36z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M38.36 119.87a23.45 23.45 0 00-5.49.79l1.24.9a12 12 0 01-4.33 0v3.69a17.32 17.32 0 007.31-.67l-.57-.7a15.79 15.79 0 011.84-.08 19.58 19.58 0 015.49.76v-3.92a23.28 23.28 0 00-5.49-.77z'
        />
        <path
          className='feature3-2_svg__cls-8'
          d='M44.19 134.2a17.38 17.38 0 00-3.09.61v1.09a22.12 22.12 0 01-5.55.53 22.27 22.27 0 01-5.43-1.23v-3.9a16.44 16.44 0 006.7 1.35 21.21 21.21 0 003.85-.37l-.18-1a13.13 13.13 0 013.7-.95zM41.79 125.33a19.2 19.2 0 00-3.84.47l.64 1a16 16 0 01-3.92.36 18.25 18.25 0 01-6.74-1.36v3.91a18.67 18.67 0 005.86 1 19.24 19.24 0 006.18-1l-.18-.48a15.36 15.36 0 012-.13 15.53 15.53 0 014 .4v-3.93a23.56 23.56 0 00-4-.24z'
        />
        <path
          className='feature3-2_svg__cls-2'
          d='M10.16 110.3h53.31v34.5H66v-34a3 3 0 00-3-3H10.65a3 3 0 00-3 3v34h2.5zM1 144.8a3.34 3.34 0 003.33 3.36h65a3.34 3.34 0 003.33-3.36zM69.5 126.96h22.99v2.02H69.5z'
        />
        <path className='feature3-2_svg__cls-2' d='M91.91 121.91l8 6.06-8 6.06M594.27 127.48h23.99v2.02h-23.99z' />
        <path className='feature3-2_svg__cls-2' d='M617.68 122.43l8 6.06-8 6.06' />
        <text className='feature3-2_svg__cls-22' transform='matrix(.99 0 0 1 18.38 169.97)'>
          {'\u53D1\u9001\u7AEF'}
        </text>
        <text className='feature3-2_svg__cls-22' transform='matrix(.99 0 0 1 638.81 169.97)'>
          {'\u63A5\u6536\u7AEF'}
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 165.88 91.96)'>
          {'\u6587\u4EF6\u57571'}
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 165.88 156.91)'>
          {'\u6587\u4EF6\u57572'}
        </text>
        <text className='feature3-2_svg__cls-12' transform='matrix(.99 0 0 1 165.88 216.87)'>
          {'\u6587\u4EF6\u5757...'}
        </text>
        <path
          className='feature3-2_svg__cls-2'
          transform='rotate(-45.01 540.617 94.156)'
          d='M540.13 62.42h1.01v63.46h-1.01z'
        />
        <path className='feature3-2_svg__cls-2' d='M560.73 118.52l4.97.68-.68-4.97' />
        <path
          className='feature3-2_svg__cls-2'
          transform='rotate(-44.99 540.666 160.358)'
          d='M508.91 159.86h63.46v1.01h-63.46z'
        />
        <path className='feature3-2_svg__cls-2' d='M560.73 135.99l4.97-.68-.68 4.97M520.92 125.75h39.48v1.01h-39.48z' />
        <path className='feature3-2_svg__cls-2' d='M560.12 123.23l3.99 3.03-3.99 3.03' />
        <text
          transform='matrix(.7 .7 -.71 .71 528.27 69.6)'
          fontSize={11.99}
          fontFamily='SourceHanSansCN-Regular-GBpc-EUC-H,Source Han Sans CN'
          fill='#252a3a'
        >
          {'\u6587\u4EF6\u5757\u5408\u5E76'}
        </text>
        <path
          className='feature3-2_svg__cls-7'
          d='M509.4 50.23h-14.24v24.23H515v-19zm-12.59 22.56V51.9h10.76v5h5.79v15.89z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M498.47 60.26h7.73v1.67h-7.73zM498.47 64.44h12.41v1.67h-12.41zM498.47 68.62h12.41v1.67h-12.41zM509.4 116.18h-14.24v24.24H515v-19zm-12.59 22.57v-20.9h10.76v5h5.79v15.88z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M498.47 126.21h7.73v1.67h-7.73zM498.47 130.39h12.41v1.67h-12.41zM498.47 134.57h12.41v1.67h-12.41zM509.4 178.14h-14.24v24.23H515v-19zm-12.59 22.56v-20.89h10.76v5h5.79v15.89z'
        />
        <path
          className='feature3-2_svg__cls-7'
          d='M498.47 188.17h7.73v1.67h-7.73zM498.47 192.34h12.41v1.67h-12.41zM498.47 196.52h12.41v1.67h-12.41z'
        />
        <text className='feature3-2_svg__cls-24' transform='matrix(.99 0 0 1 487.03 91.96)'>
          {'\u6587\u4EF6\u57571'}
        </text>
        <text className='feature3-2_svg__cls-24' transform='matrix(.99 0 0 1 487.03 156.91)'>
          {'\u6587\u4EF6\u57572'}
        </text>
        <text className='feature3-2_svg__cls-24' transform='matrix(.99 0 0 1 487.03 216.87)'>
          {'\u6587\u4EF6\u5757...'}
        </text>
        <path
          fill='none'
          stroke='#8796aa'
          strokeMiterlimit={10}
          strokeDasharray='4 4'
          d='M102.56 158.1v91.08h481.29l-.14-92.27'
        />
        <path className='feature3-2_svg__cls-2' d='M586.73 158.1l-2.96-4.04-3.1 3.94' />
      </g>
    </g>
  </svg>
)

export default SvgFeature32
